export default __webpack_public_path__ + "static/media/Group1043@2x.3e93ab20.png";